//app.jsx
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import Login from "./pages/login/Login.jsx";
import PaidSignup from "./pages/signup/PaidSignup.jsx";
import TrialSignup from "./pages/signup/TrialSignup.jsx";
import Dashboard from "./pages/dashboard/Dashboard.jsx";
import ThreeCanvas from "./pages/canvas/Canvas.jsx";
import ProtectedRoute from "./components/auth/ProtectedRoute.jsx";
import SubscriptionRequired from "./pages/subscription/SubscriptionRequired.jsx";
import useTrialExpiration from "./utils/useTrialExpiration.js";


const App = () => {
  return (
    <HelmetProvider>
      <AuthProvider>
        <Router>
          <AppWithNavigation />
        </Router>
      </AuthProvider>
    </HelmetProvider>
  );
};

const AppWithNavigation = () => {
  const { currentUser } = useAuth();
  
  // Enable trial expiration checking for authenticated users
  useTrialExpiration();

  return (
    <Routes>
      <Route
        path="/login"
        element={
          currentUser ? (
            <Navigate to="/dashboard" replace />
          ) : (
            <Login />
          )
        }
      />



      <Route
        path="/signup/paid"
        element={
          currentUser ? (
            <Navigate to="/dashboard" replace />
          ) : (
            <PaidSignup />
          )
        }
      />

      <Route
        path="/signup/trial"
        element={
          currentUser ? (
            <Navigate to="/dashboard" replace />
          ) : (
            <TrialSignup />
          )
        }
      />

      <Route path="/subscription-required" element={<SubscriptionRequired />} />

      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/canvas"
        element={
          <ProtectedRoute>
            <ThreeCanvas />
          </ProtectedRoute>
        }
      />
      
      <Route path="/" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};

export default App;